import templateUrl from './website-url-modal.html'
import './website-url-modal.scss'
import { urlPattern } from '../../../project-presets/project-presets.config'

const WebsiteUrlModalComponent = {
  bindings: {
    project: '<'
  },
  require: {
    modalCtrl: '^cdblModal'
  },
  templateUrl,
  controller: class WebsiteUrlModal {
    constructor (ProjectService, $http, Configuration) {
      'ngInject'
      this._identify = 'WebsiteUrlModalComponent'
      this.ProjectService = ProjectService
      this.$http = $http
      this.Configuration = Configuration
    }

    $onInit () {
      this.urlPattern = urlPattern
      this.websiteUrl = this.project.websiteUrl || ''
      this.isProcessing = false
    }

    save () {
      if (this.websiteUrlForm.$invalid || this.isProcessing) {
        return
      }

      this.isProcessing = true

      // Update the project's website URL
      this.ProjectService.updateProjectWebsiteUrl(this.project, this.websiteUrl)
        .then(response => {
          // Update the project object with the new URL
          // Use response.websiteUrl if available, otherwise use the value we sent
          const updatedUrl = response.websiteUrl || response.data?.websiteUrl || this.websiteUrl
          this.project.websiteUrl = updatedUrl

          // Also update the project in ProjectService if it's the same reference
          if (this.ProjectService.project && this.ProjectService.project.id === this.project.id) {
            this.ProjectService.project.websiteUrl = updatedUrl
          }

          this.modalCtrl.close()
        })
        .catch(error => {
          console.error('Error updating website URL:', error)
          // TODO: Show error message to user
        })
        .finally(() => {
          this.isProcessing = false
        })
    }

    cancel () {
      this.modalCtrl.close()
    }
  }
}

export default WebsiteUrlModalComponent
